(function () {
  'use strict';

  // ===== i18n bridge: read translations from Liquid-rendered JSON block =====
  var T = (function () {
    var el = document.querySelector('script[type="application/json"][data-pickmix-i18n]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();
  function tCount(tpl, count) {
    return (tpl || '').replace('__COUNT__', count);
  }
  function tFmt(tpl, vars) {
    var out = tpl || '';
    Object.keys(vars).forEach(function (k) {
      out = out.split('__' + k.toUpperCase() + '__').join(vars[k]);
    });
    return out;
  }
  function tPlural(oneTpl, otherTpl, count) {
    return tCount(count === 1 ? oneTpl : otherTpl, count);
  }
  function formatImperialWeight(grams) {
    // Customer model (Ian, 27 Aug 2026): one 100 g click is shown, sold and packed
    // as 0.2 lb. Candy amounts are always whole clicks → clicks × 0.2 lb, so five
    // clicks read exactly 1 lb. Bag sizes (454/907/1360/1814 g) are never a
    // multiple of 100 and keep the true conversion (1 lb, 2 lb …). The ledger
    // books the full 100 g per click via _Ledger grams — the ~9 g/click gap is a
    // deliberate shrinkage buffer.
    var pounds = (grams % 100 === 0) ? grams / 500 : grams / 453.59237;
    var rounded = Math.round(pounds * 10) / 10;
    if (Math.abs(rounded - Math.round(rounded)) < 0.001) return Math.round(rounded) + ' lb';
    return rounded.toFixed(1).replace(/\.0$/, '') + ' lb';
  }
  function formatMetricWeight(grams) {
    return grams + 'g';
  }

  function parseBagGrams(btn) {
    // In imperial markets, data-fill-grams can decouple candy fill from packed
    // shipping weight so the box has room for packaging.
    var fill = parseInt(btn && btn.dataset && btn.dataset.fillGrams, 10);
    if (!isNaN(fill) && fill > 0) return fill;
    // Prefer Shopify's authoritative variant.grams emitted as data-grams.
    // Fall back to regex-scraping the visible title only if that's missing.
    // Regex accepts both '1.5kg' (.com) and '1,5 kg' (.se) decimal styles —
    // an English-only '\.' would mis-parse '1,5 kg' as 5kg → 5000g.
    var n = parseInt(btn && btn.dataset && btn.dataset.grams, 10);
    if (!isNaN(n) && n > 0) return n;
    var title = btn && btn.dataset ? (btn.dataset.variantTitle || '') : String(btn || '');
    var m = title.match(/(\d+(?:[.,]\d+)?)\s*(kg|g)/i);
    if (!m) return 500;
    var v = parseFloat(m[1].replace(',', '.'));
    return /kg/i.test(m[2]) ? Math.round(v * 1000) : Math.round(v);
  }

  function formatMoney(amountMinor, template) {
    // Shopify's money strings already render in shop currency. We re-use a known
    // formatted price string (data-price-formatted) and substitute the numeric
    // portion. amountMinor is in cents/öre.
    var amount = (amountMinor / 100).toFixed(2);
    if (!template) return amount;
    return template.replace(/[\d.,]+/, amount.replace('.', template.indexOf(',') > template.indexOf('.') ? ',' : '.'));
  }

  function formatMoneyFromCents(amountMinor, template) {
    var amount = Math.max(0, amountMinor);
    return formatMoney(amount, template);
  }

  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstChild;
  }

  // ---- Reduced-motion fast-path ----
  // Sidebar item enter/exit animations (Lovable §A.5 AnimatePresence) need a
  // JS-side check because the exit path schedules a setTimeout to remove the
  // DOM node AFTER the CSS animation finishes. With reduced motion the CSS
  // animation is none — there'd be nothing to wait for, so EXIT_MS goes to 0
  // and DOM removal happens immediately. Sampled once on module init; users
  // who toggle the OS preference mid-session need a reload to pick it up.
  var REDUCE_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SIDEBAR_EXIT_MS = REDUCE_MOTION ? 0 : 300;
  var SIDEBAR_ENTER_MS = 300; // matches @keyframes pickmix-selected-enter duration

  /**
   * Build a sidebar selected-candy item DOM node.
   * IMPORTANT: writes data-id on the root .pickmix__selected-item so
   * reconcileSelectedList() can match DOM nodes back to selectedCandies map keys.
   */
  function buildSelectedItem(candy, adjustCandy, removeCandy, GRAMS, T, formatWeight) {
    var stepLabel = formatWeight(GRAMS);
    var addLabel = T && T.a11y_add_grams_named
      ? (T.a11y_add_grams_named || '').split('__CANDY__').join(candy.title).replace(GRAMS + ' grams', stepLabel).replace(GRAMS + 'g', stepLabel) : ('Add ' + stepLabel + ' of ' + candy.title);
    var subLabel = T && T.a11y_remove_grams_named
      ? (T.a11y_remove_grams_named || '').split('__CANDY__').join(candy.title).replace(GRAMS + ' grams', stepLabel).replace(GRAMS + 'g', stepLabel) : ('Remove ' + stepLabel + ' of ' + candy.title);
    var rmLabel  = T && T.a11y_remove_candy_from_bag
      ? (T.a11y_remove_candy_from_bag || '').split('__CANDY__').join(candy.title) : ('Remove ' + candy.title + ' from bag');
    var item = el(
      '<div class="pickmix__selected-item is-entering">' +
        '<span class="pickmix__selected-name"></span>' +
        '<div class="pickmix__selected-controls">' +
          '<button type="button" class="pickmix__qty-btn" data-dec></button>' +
          '<span class="pickmix__selected-grams"></span>' +
          '<button type="button" class="pickmix__qty-btn" data-inc></button>' +
          '<button type="button" class="pickmix__qty-btn pickmix__qty-btn--remove" data-remove>×</button>' +
        '</div>' +
      '</div>'
    );
    item.dataset.id = candy.id; // required by reconcile()
    item.querySelector('.pickmix__selected-name').textContent = candy.title;
    item.querySelector('.pickmix__selected-grams').textContent = formatWeight(candy.grams);
    var decBtn = item.querySelector('[data-dec]');
    var incBtn = item.querySelector('[data-inc]');
    var rmBtn  = item.querySelector('[data-remove]');
    decBtn.setAttribute('aria-label', subLabel); decBtn.textContent = '−';
    incBtn.setAttribute('aria-label', addLabel); incBtn.textContent = '+';
    rmBtn.setAttribute('aria-label', rmLabel);
    decBtn.addEventListener('click', function () { adjustCandy(candy.id, -GRAMS); });
    incBtn.addEventListener('click', function () { adjustCandy(candy.id, GRAMS); });
    rmBtn.addEventListener('click', function () { removeCandy(candy.id); });
    // Auto-strip is-entering after the enter animation finishes so subsequent
    // re-renders don't re-fire it. Also remove if the user instantly removes
    // the candy (the exit path will cancel any in-flight enter animation).
    setTimeout(function () { item.classList.remove('is-entering'); }, SIDEBAR_ENTER_MS);
    return item;
  }

  /**
   * Reconcile sidebar selected-list DOM against the current selectedCandies Map.
   * Strategy: diff by data-id. Each existing node is one of:
   *   - still selected → UPDATE text + button-disabled state (no animation)
   *   - still selected but was mid-exit → CANCEL exit, restore (user re-added)
   *   - no longer selected → APPLY .is-exiting, schedule DOM removal at +SIDEBAR_EXIT_MS
   * New ids with no existing node → CREATE + append (.is-entering fires once).
   *
   * Cancellation policy: any class transition between .is-entering / .is-exiting
   * / (none) MUST cancel in-flight Web Animations (`el.getAnimations().forEach(a => a.cancel())`)
   * so the new state takes effect from a clean baseline, and the pending-removal
   * setTimeout stored on el._pickmixExitTimer MUST be cleared, otherwise rapid
   * remove → re-add leaves a stale timer that yanks the DOM out from under a
   * current state entry 300ms later.
   */
  function reconcileSelectedList(container, candiesMap, remaining, GRAMS, T, formatWeight) {
    var existing = Array.from(container.querySelectorAll('.pickmix__selected-item'));
    var seenIds = {};

    existing.forEach(function (node) {
      var id = node.dataset.id;
      var candy = candiesMap.get(id);
      if (candy) {
        seenIds[id] = true;
        // Was mid-exit and user re-added → cancel exit, restore.
        if (node.classList.contains('is-exiting')) {
          if (node._pickmixExitTimer) {
            clearTimeout(node._pickmixExitTimer);
            node._pickmixExitTimer = null;
          }
          node.getAnimations().forEach(function (a) { a.cancel(); });
          node.classList.remove('is-exiting');
        }
        // Plain UPDATE — text + button disabled state. No animation re-fire.
        node.querySelector('.pickmix__selected-grams').textContent = formatWeight(candy.grams);
        var inc = node.querySelector('[data-inc]');
        if (inc) inc.disabled = remaining <= 0;
      } else {
        // No longer selected → apply exit class, schedule DOM removal.
        // Skip if already exiting (don't double-schedule).
        if (!node.classList.contains('is-exiting')) {
          // Cancel any in-flight enter animation so exit starts from clean state.
          node.getAnimations().forEach(function (a) { a.cancel(); });
          node.classList.remove('is-entering');
          node.classList.add('is-exiting');
          node._pickmixExitTimer = setTimeout(function () {
            node._pickmixExitTimer = null;
            if (node.parentNode) node.parentNode.removeChild(node);
          }, SIDEBAR_EXIT_MS);
        }
      }
    });

    // Append new items that don't have a DOM node yet.
    candiesMap.forEach(function (candy, id) {
      if (seenIds[id]) return;
      var item = buildSelectedItem(candy, container.__adjustCandy, container.__removeCandy, GRAMS, T, formatWeight);
      container.appendChild(item);
    });
  }

  function init(root) {
    var useImperial = root.dataset.weightSystem === 'imperial';
    var GRAMS = parseInt(root.dataset.gramsPerClick, 10) || 50;
    var MIN_GRAMS = parseInt(root.dataset.minGrams, 10) || 100;
    // Fill mode (16 Sep 2026, Halloween builder): 'fixed_bag' = one bag size that must be filled
    // exactly; every gram past the top starts another bag (cart quantity = number of bags).
    var FILL_MODE = root.dataset.fillMode || 'flexible';
    var FIXED = FILL_MODE === 'fixed_bag';
    var CART_ADD_URL = root.dataset.cartAddUrl || '/cart/add.js';
    var CART_URL = root.dataset.cartUrl || '/cart';
    var CURRENT_CART_TOTAL = parseInt(root.dataset.currentCartTotal, 10) || 0;
    var FREE_SHIPPING_THRESHOLD = parseInt(root.dataset.freeShippingThreshold, 10) || 0;
    // The Europe-zone rule is 640 SEK and the US/CA rule is 950 SEK (since 17 Sep 2026), both converted at checkout:
    // refine the static figure from snippets/free-shipping-threshold.liquid with the live rate (whole units, rounded up).
    (function () {
      var sek = parseInt(root.dataset.freeShippingThresholdSek, 10) || 0;
      var cur = window.Shopify && window.Shopify.currency;
      if (sek && cur && cur.rate && cur.active !== 'SEK' && parseFloat(cur.rate) > 0) {
        FREE_SHIPPING_THRESHOLD = Math.ceil((sek * parseFloat(cur.rate)) / 100) * 100;
      }
    })();
    var CART_JSON_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/')
      .replace(/\/?$/, '/cart.js');

    // ---- State ----
    var selectedBag = null;        // { id, title, price, grams, priceFormatted }
    var selectedCandies = new Map(); // id -> { id, title, grams }
    var selectedUpsells = new Map(); // id -> { id, variantId, title, price, priceFormatted }
    var moneyTemplate = null;      // captured from first variant for formatting totals

    // Bag-full UX flags (reset on bag size change OR drop below 100%)
    var hasCelebrated = false;        // State 1 (celebration overlay) already fired this fill
    var hasShownUpgradeToast = false; // State 2 (upgrade toast) already fired this session

    // HOTFIX (2026-08-03): Race condition guard for bag-full auto-upgrade.
    // When bag fills and auto-upgrade fires, block clicks during the 400ms animation
    // to prevent concurrent state mutations on both old and new bag size.
    // Bug report: Order #1028 showed Maoam 0.7 lb (should 0.8) and BUBS 0 lb (should 0.2)
    // caused by rapid clicks during bag-full transition.
    var isUpgrading = false;

    function formatWeight(grams) {
      return useImperial ? formatImperialWeight(grams) : formatMetricWeight(grams);
    }
    function tWeight(tpl, grams) {
      var weight = formatWeight(grams);
      return (tpl || '')
        .replace('__COUNT__ grams', weight)
        .replace('__COUNT__g', weight)
        .replace('__COUNT__', weight);
    }
    function tFmtWeights(tpl, vars) {
      var out = tpl || '';
      Object.keys(vars).forEach(function (k) {
        var token = '__' + k.toUpperCase() + '__';
        var weight = formatWeight(vars[k]);
        out = out
          .split(token + ' grams').join(weight)
          .split(token + 'g').join(weight)
          .split(token).join(weight);
      });
      return out;
    }
    function displayBagTitle(btn) {
      if (!btn) return '';
      return btn.dataset.displayTitle || btn.dataset.variantTitle || '';
    }

    // ---- DOM refs ----
    var bags = Array.from(root.querySelectorAll('[data-bag]'));
    var candies = Array.from(root.querySelectorAll('[data-candy]'));
    var upsellEls = Array.from(root.querySelectorAll('[data-upsell]'));
    var search = root.querySelector('[data-search]');
    var candiesGrid = root.querySelector('[data-candies]');
    var selectedBox = root.querySelector('[data-selected]');
    var selectedEmpty = root.querySelector('[data-selected-empty]');
    var selectedUpsellsBox = root.querySelector('[data-selected-upsells]');
    var selectedUpsellsList = root.querySelector('[data-selected-upsells-list]');
    var totalEl = root.querySelector('[data-total]');
    var totalMeta = root.querySelector('[data-total-meta]');
    var ctaBtn = root.querySelector('[data-add-to-cart]');
    var ctaLabel = root.querySelector('[data-cta-label]');
    var ctaBtnMobile = root.querySelector('[data-add-to-cart-mobile]');
    var mobileProgress = root.querySelector('[data-mobile-progress]');
    var progressLabel = root.querySelector('[data-progress-label]');
    var progressLabelDesktop = root.querySelector('[data-progress-label-desktop]');
    var progressRemaining = root.querySelector('[data-progress-remaining]');
    var progressFill = root.querySelector('[data-progress-fill]');
    var progressFillDesktop = root.querySelector('[data-progress-fill-desktop]');
    var progressNote = root.querySelector('[data-progress-note]');
    var builderShippingBlocks = Array.from(root.querySelectorAll('[data-builder-shipping]'));
    var builderShippingMessages = Array.from(root.querySelectorAll('[data-builder-shipping-message]'));
    var builderShippingFills = Array.from(root.querySelectorAll('[data-builder-shipping-fill]'));
    var builderShippingUpsells = Array.from(root.querySelectorAll('[data-builder-shipping-upsell]'));
    var floating = root.querySelector('[data-floating]');
    var floatingPrice = root.querySelector('[data-floating-price]');
    var floatingMeta = root.querySelector('[data-floating-meta]');
    var stepNums = Array.from(root.querySelectorAll('[data-num]'));
    var stepIndicators = Array.from(root.querySelectorAll('[data-step]'));
    var announcer = root.querySelector('[data-pickmix-announce]');
    var announceTimer = null;
    var hasAnnouncedOnce = false; // skip first render so SR doesn't read on load

    // ---- Helpers ----
    function totalGrams() {
      var t = 0;
      selectedCandies.forEach(function (c) { t += c.grams; });
      return t;
    }
    function upsellsTotal() {
      var t = 0;
      selectedUpsells.forEach(function (u) { t += u.price; });
      return t;
    }
    // Fixed-bag helpers: unit = grams per bag; nBags = bags started so far (min 1); target = nBags × unit.
    function bagUnit() { return selectedBag ? selectedBag.grams : 0; }
    function bagCount() {
      var u = bagUnit(); if (!u) return 1;
      var t = totalGrams();
      return t > 0 ? Math.ceil(t / u) : 1;
    }
    function targetGrams() { return FIXED ? bagUnit() * bagCount() : bagUnit(); }
    function isExactlyFull() { var u = bagUnit(); var t = totalGrams(); return u > 0 && t > 0 && t % u === 0; }
    function belowFull() { return FIXED ? !isExactlyFull() : (!!selectedBag && totalGrams() < selectedBag.grams); }
    function syncFullFlags() { if (belowFull()) { hasCelebrated = false; hasShownUpgradeToast = false; } }
    function currentStep() {
      if (selectedCandies.size === 0) return 1;
      if (FIXED) return isExactlyFull() ? 3 : 2;
      if (selectedBag && totalGrams() >= selectedBag.grams) return 3;
      return 2;
    }

    // ---- Render ----
    function render() {
      var bagGrams = selectedBag ? selectedBag.grams : 0;
      var t = totalGrams();
      var nBags = FIXED ? bagCount() : 1;
      var target = FIXED ? bagGrams * nBags : bagGrams;
      var inBag = FIXED ? t - (nBags - 1) * bagGrams : t; // grams in the bag currently being filled
      var pct = bagGrams ? Math.min(100, (inBag / bagGrams) * 100) : 0;
      var remaining = Math.max(0, target - t);

      // Bag selection visuals
      bags.forEach(function (b) {
        var active = selectedBag && b.dataset.variantId === selectedBag.id;
        b.classList.toggle('is-active', !!active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      // Progress
      var label = formatWeight(inBag) + ' / ' + formatWeight(bagGrams);
      if (FIXED && nBags > 1) label += ' · ' + tFmt(T.fixed_bag_of, { current: nBags, total: nBags });
      if (progressLabel) progressLabel.textContent = label;
      if (progressLabelDesktop) progressLabelDesktop.textContent = label;
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressFillDesktop) progressFillDesktop.style.width = pct + '%';

      var fillState = pct >= 100 ? 'full' : pct >= 75 ? 'high' : 'normal';
      [progressFill, progressFillDesktop].forEach(function (f) {
        if (!f) return;
        f.dataset.state = fillState;
      });

      if (progressRemaining) {
        if (!FIXED && bagGrams > 0 && t > bagGrams && formatWeight(t) !== formatWeight(bagGrams)) {
          progressRemaining.textContent = '+' + formatWeight(t - bagGrams) + ' extra included';
          progressRemaining.dataset.rem = 'full';
        } else if (remaining === 0 && bagGrams > 0) {
          progressRemaining.textContent = T.bag_full_short;
          progressRemaining.dataset.rem = 'full';
        } else if (remaining <= 100 && remaining > 0) {
          progressRemaining.textContent = tWeight(T.remaining_with_count, Math.ceil(remaining / GRAMS) * GRAMS);
          progressRemaining.dataset.rem = 'low';
        } else {
          progressRemaining.textContent = formatWeight(Math.ceil(remaining / GRAMS) * GRAMS) + ' remaining';
          delete progressRemaining.dataset.rem;
        }
      }

      if (progressNote) {
        if (pct >= 100) {
          progressNote.textContent = T.bag_full;
          progressNote.hidden = false;
          progressNote.dataset.state = 'full';
        } else if (pct >= 80) {
          progressNote.textContent = tWeight(T.almost_there, remaining);
          progressNote.hidden = false;
          progressNote.dataset.state = 'near';
        } else {
          progressNote.hidden = true;
        }
      }

      if (mobileProgress) mobileProgress.hidden = !selectedBag;

      // Candies: grams badge + selected styling + disable when full.
      // Badge pop-in (Lovable initial scale:0 → animate scale:1) fires only
      // on first appearance — i.e., when the badge transitions hidden→visible,
      // not on every grams update.
      candies.forEach(function (c) {
        var picked = selectedCandies.get(c.dataset.id);
        var badge = c.querySelector('[data-candy-grams]');
        var ctaEl = c.querySelector('[data-candy-cta]');
        var stepper = c.querySelector('[data-candy-stepper]');
        var stepperGrams = c.querySelector('[data-candy-step-grams]');
        if (picked) {
          c.classList.add('is-selected');
          // Swap card footer: stepper visible, +Add CTA hidden.
          if (stepper) stepper.hidden = false;
          if (ctaEl) ctaEl.hidden = true;
          if (stepperGrams) stepperGrams.textContent = formatWeight(picked.grams);
          if (badge) {
            var wasHidden = badge.hidden;
            badge.textContent = formatWeight(picked.grams);
            badge.hidden = false;
            if (wasHidden) {
              badge.classList.add('is-popping');
              setTimeout(function () { badge.classList.remove('is-popping'); }, 300);
            }
          }
        } else {
          c.classList.remove('is-selected');
          if (badge) { badge.hidden = true; }
          // Swap card footer back: +Add CTA visible, stepper hidden.
          if (stepper) stepper.hidden = true;
          if (ctaEl) ctaEl.hidden = false;
        }
        var stock = stockOf(c);
        var soldout = stock === 0;
        var atMax = stock > 0 && picked && picked.grams >= stock;
        c.classList.toggle('is-soldout', soldout);
        c.classList.toggle('is-atmax', !!atMax);
        var incBtn = c.querySelector('[data-candy-inc]');
        if (incBtn) incBtn.disabled = !!atMax;
        var disabled = (!FIXED && remaining <= 0 && !picked) || soldout;
        c.classList.toggle('is-disabled', disabled);
        if (disabled) c.setAttribute('aria-disabled', 'true'); else c.removeAttribute('aria-disabled');
      });

      // Selected list — reconcile in place so per-item enter/exit animations
      // can play (Lovable §A.5 AnimatePresence parity). Full wipe + rebuild
      // would destroy animation state and re-fire enter on every render.
      if (selectedBox) {
        selectedBox.__adjustCandy = adjustCandy; // closure bridge for buildSelectedItem
        selectedBox.__removeCandy = removeCandy; // closure bridge for the × button
        if (selectedCandies.size === 0 && selectedBox.querySelectorAll('.pickmix__selected-item:not(.is-exiting)').length === 0) {
          if (selectedEmpty) selectedEmpty.hidden = false;
        } else {
          if (selectedEmpty) selectedEmpty.hidden = true;
        }
        reconcileSelectedList(selectedBox, selectedCandies, FIXED ? Infinity : remaining, GRAMS, T, formatWeight);
      }

      // Upsells
      upsellEls.forEach(function (u) {
        u.classList.toggle('is-selected', selectedUpsells.has(u.dataset.id));
      });
      if (selectedUpsellsBox) {
        selectedUpsellsBox.hidden = selectedUpsells.size === 0;
        if (selectedUpsellsList) {
          selectedUpsellsList.innerHTML = '';
          selectedUpsells.forEach(function (u) {
            var li = el('<li><span></span><span></span></li>');
            li.children[0].textContent = u.title;
            li.children[1].textContent = '+ ' + u.priceFormatted;
            selectedUpsellsList.appendChild(li);
          });
        }
      }

      // Total
      var bagPrice = selectedBag ? selectedBag.price * nBags : 0;
      var total = bagPrice + upsellsTotal();
      var totalStr = selectedBag ? formatMoney(total, moneyTemplate || selectedBag.priceFormatted) : '—';
      if (totalEl) totalEl.textContent = totalStr;
      if (totalMeta) {
        var parts = [];
        if (selectedBag && FIXED) parts.push(nBags === 1 ? (T.fixed_bag_one || '1 bag') : tCount(T.fixed_bags_count || '__COUNT__ bags', nBags));
        else if (selectedBag) parts.push(selectedBag.displayTitle || selectedBag.title);
        parts.push(tPlural(T.candy_count_one, T.candy_count_other, selectedCandies.size));
        if (selectedUpsells.size > 0) parts.push(selectedUpsells.size + ' extra' + (selectedUpsells.size === 1 ? '' : 's'));
        totalMeta.textContent = parts.join(' · ');
      }

      if (builderShippingBlocks.length) {
        var hasFreeShippingTarget = FREE_SHIPPING_THRESHOLD > 0;
        if (hasFreeShippingTarget && selectedBag) {
          var fillRatio = selectedBag.grams ? (FIXED ? t / selectedBag.grams : Math.min(1, t / selectedBag.grams)) : 0;
          var projectedBagValue = Math.round(selectedBag.price * fillRatio);
          var projectedTotal = CURRENT_CART_TOTAL + projectedBagValue + upsellsTotal();
          var shippingPct = Math.min(100, (projectedTotal / FREE_SHIPPING_THRESHOLD) * 100);
          var shippingRemaining = Math.max(0, FREE_SHIPPING_THRESHOLD - projectedTotal);
          var shippingComplete = shippingRemaining <= 0;

          builderShippingBlocks.forEach(function (block) {
            block.hidden = false;
            block.classList.toggle('is-complete', shippingComplete);
          });

          builderShippingFills.forEach(function (fill) {
            fill.style.width = shippingPct + '%';
          });

          builderShippingMessages.forEach(function (message) {
            var messageTemplate = shippingComplete
              ? message.dataset.completeTemplate
              : message.dataset.moreTemplate;
            message.textContent = (messageTemplate || '').replace(
              '__AMOUNT__',
              formatMoneyFromCents(shippingRemaining, moneyTemplate || selectedBag.priceFormatted)
            );
          });

          builderShippingUpsells.forEach(function (upsell) {
            upsell.hidden = shippingComplete;
          });
        } else {
          builderShippingBlocks.forEach(function (block) {
            block.hidden = true;
          });
        }
      }

      // CTA — gate on FULL bag (currentGrams >= bag target), not the 100g floor.
      // SOFIA-FILL-1: underfilled bags previously checked out at full bag price.
      // selectedBag.grams comes from data-grams (variant.grams) — no title parsing.
      var canCheckout = FIXED ? isExactlyFull() : (!!selectedBag && t >= selectedBag.grams);
      var ctaText;
      if (!selectedBag) ctaText = FIXED ? (T.fixed_choose_style || T.cta_choose_bag_size) : T.cta_choose_bag_size;
      else if (selectedCandies.size === 0) ctaText = T.cta_pick_candies;
      else if (!canCheckout) ctaText = tFmtWeights(T.cta_fill_bag, { remaining: target - t, current: inBag, target: bagGrams });
      else if (FIXED && nBags > 1) ctaText = tFmt(T.cta_add_to_cart_bags, { count: nBags, total: totalStr });
      else ctaText = tFmt(T.cta_add_to_cart_with_total, { total: totalStr });
      if (ctaLabel) ctaLabel.textContent = ctaText;
      if (ctaBtn) ctaBtn.disabled = !canCheckout;
      if (ctaBtnMobile) {
        ctaBtnMobile.disabled = !canCheckout;
        ctaBtnMobile.textContent = canCheckout ? T.cta_add_to_cart : (selectedCandies.size === 0 ? T.cta_pick_candies : tFmtWeights(T.cta_fill_bag_short, { remaining: target - t }));
      }

      // Mobile floating
      if (floating) {
        floating.hidden = selectedCandies.size === 0;
        if (floatingPrice) floatingPrice.textContent = totalStr;
        if (floatingMeta) {
          var fm = tFmtWeights(T.meta_with_counts, { weight: t }).replace('__COUNT__', selectedCandies.size);
          if (FIXED && nBags > 1) fm = tCount(T.fixed_bags_count || '__COUNT__ bags', nBags) + ' · ' + fm;
          if (selectedUpsells.size > 0) fm += ' + ' + tPlural(T.extras_count_one, T.extras_count_other, selectedUpsells.size);
          floatingMeta.textContent = fm;
        }
      }

      // Steps
      var step = currentStep();
      stepNums.forEach(function (n) {
        var s = parseInt(n.dataset.num, 10);
        n.classList.toggle('is-done', step > s);
        n.classList.toggle('is-active', step === s);
      });
      stepIndicators.forEach(function (n) {
        var s = parseInt(n.dataset.step, 10);
        n.classList.toggle('is-done', step > s);
        n.classList.toggle('is-active', step === s);
      });

      // Debounced screen-reader announcement (500ms). Skips first render so the
      // SR doesn't read the empty bag on page load.
      if (announcer) {
        if (!hasAnnouncedOnce) { hasAnnouncedOnce = true; }
        else {
          if (announceTimer) clearTimeout(announceTimer);
          announceTimer = setTimeout(function () {
            var msg = tFmtWeights(T.a11y_qty_updated || 'Bag: __COUNT__ candies, __WEIGHT__g of __TOTAL__g', {
              weight: totalGrams(),
              total: target
            }).replace('__COUNT__', selectedCandies.size);
            announcer.textContent = msg;
          }, 500);
        }
      }
    }

    // ---- Bag-full UX ----
    function findNextLargerBag(currentGrams) {
      var best = null;
      var bestGrams = Infinity;
      bags.forEach(function (b) {
        var g = parseBagGrams(b);
        if (g > currentGrams && g < bestGrams) {
          best = b;
          bestGrams = g;
        }
      });
      return best;
    }

    function showCelebration() {
      var overlay = root.querySelector('[data-bagfull-overlay]');
      if (!overlay) return;
      // Randomise the 6 sparkles per Lovable's pattern (per-particle delay + duration + position)
      var sparkles = overlay.querySelectorAll('[data-sparkle-index]');
      sparkles.forEach(function (sp, i) {
        sp.style.top = (20 + Math.random() * 60) + '%';
        sp.style.left = (10 + Math.random() * 80) + '%';
        sp.style.setProperty('--pm-sparkle-delay', (i * 0.2) + 's');
        sp.style.setProperty('--pm-sparkle-duration', (1 + Math.random()) + 's');
      });
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      setTimeout(function () {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
      }, 2200);
    }

    function showUpgradeToast() {
      if (!window.PickMixToast) return;
      var currentGrams = selectedBag.grams;
      var nextBtn = findNextLargerBag(currentGrams);
      var msg, onClick;
      if (nextBtn) {
        var nextGrams = parseBagGrams(nextBtn);
        var key = 'bagfull_upgrade_cta_' + currentGrams + '_to_' + nextGrams;
        msg = T[key] || T.bagfull_upgrade_cta_500_to_1000 || 'Bag full · Upgrade for more room';
        if (useImperial) msg = 'Bag full · Upgrade to ' + displayBagTitle(nextBtn) + ' for more room';
        onClick = function () { selectBag(nextBtn); };
      } else {
        // At max bag size — informational only, no action.
        // (User dismisses by clicking; the prominent Add to Cart button in the
        // sidebar / floating mobile bar is the real next step.)
        msg = T.bagfull_at_max_size || 'Bag at max size · Add to Cart below to check out';
        onClick = null;
      }
      window.PickMixToast.show(msg, { onClick: onClick, duration: 5000 });
    }

    function handleBagFullReached() {
      if (!selectedBag) return;
      if (FIXED) {
        // Fixed bag: celebrate each exact fill; no size-upgrade toast — the next click simply starts bag N+1.
        if (!isExactlyFull()) return;
        if (!hasCelebrated) { showCelebration(); hasCelebrated = true; }
        if (!hasShownUpgradeToast && window.PickMixToast) {
          window.PickMixToast.show(T.fixed_bag_full_toast || 'Bag full · Add to cart, or keep clicking to start another bag', { onClick: null, duration: 5000 });
          hasShownUpgradeToast = true;
        }
        return;
      }
      if (totalGrams() < selectedBag.grams) return;
      if (!hasCelebrated) {
        showCelebration();
        hasCelebrated = true;
      }
      if (!hasShownUpgradeToast) {
        showUpgradeToast();
        hasShownUpgradeToast = true;
      }
    }

    function upgradeToNextBag() {
      if (!selectedBag) return false;
      var nextBtn = findNextLargerBag(selectedBag.grams);
      if (!nextBtn) return false;
      selectBag(nextBtn, false);
      return true;
    }

    // ---- Actions ----
    // SOFIA-BUILDER-1: gate auto-collapse on real user interaction only.
    // The default-bag selection at init also calls selectBag() — we don't want to
    // collapse Step 1 on first page-load (user hasn't picked yet; that IS the action).
    // Reusable primitive for any future wizard-style UI: distinguish init from user-click.
    var userHasInteracted = false;
    function selectBag(btn, fromUser) {
      var newGrams = parseBagGrams(btn);
      var priceMinor = parseInt(btn.dataset.price, 10);
      var priceFmt = btn.dataset.priceFormatted;
      if (!moneyTemplate) moneyTemplate = priceFmt;
      selectedBag = {
        id: btn.dataset.variantId,
        title: btn.dataset.variantTitle,
        displayTitle: displayBagTitle(btn),
        grams: newGrams,
        price: priceMinor,
        priceFormatted: priceFmt
      };
      // Trim candies if new bag is smaller
      var t = totalGrams();
      if (t > newGrams) {
        var over = t - newGrams;
        // Drop most recently added first (Map preserves insertion order)
        var keys = Array.from(selectedCandies.keys()).reverse();
        for (var i = 0; i < keys.length && over > 0; i++) {
          var c = selectedCandies.get(keys[i]);
          if (c.grams <= over) {
            over -= c.grams;
            selectedCandies.delete(keys[i]);
          } else {
            c.grams -= over;
            over = 0;
          }
        }
      }
      // Reset bag-full UX flags on bag size change
      hasCelebrated = false;
      hasShownUpgradeToast = false;
      render();
      // SOFIA-BUILDER-1: keep collapsed-summary text in sync with selectedBag,
      // and trigger the mobile auto-collapse only on a real user interaction.
      populateCollapsedBagSummary();
      if (fromUser && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        collapseBagCard();
      }
    }

    // SOFIA-BUILDER-1 helpers ─────────────────────────────────────
    var bagCard = root.querySelector('[data-bag-card]');
    var collapsedNameEl = root.querySelector('[data-collapsed-bag-name]');
    var collapsedPriceEl = root.querySelector('[data-collapsed-bag-price]');
    var changeBtn = root.querySelector('[data-bag-change]');
    var candiesCard = root.querySelector('[data-card="candies"]');

    function populateCollapsedBagSummary() {
      if (!selectedBag) return;
      if (collapsedNameEl) collapsedNameEl.textContent = selectedBag.displayTitle || selectedBag.title;
      if (collapsedPriceEl) collapsedPriceEl.textContent = selectedBag.priceFormatted;
    }
    function collapseBagCard() {
      if (!bagCard) return;
      bagCard.classList.add('is-collapsed');
      if (changeBtn) changeBtn.setAttribute('aria-expanded', 'false');
      // Bring Step 2 (candy grid) into the viewport now that Step 1 has shrunk.
      // Delay matches the .pickmix__card-collapsed animation duration (300ms).
      if (candiesCard) {
        setTimeout(function () {
          candiesCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 320);
      }
    }
    function expandBagCard() {
      if (!bagCard) return;
      bagCard.classList.remove('is-collapsed');
      if (changeBtn) changeBtn.setAttribute('aria-expanded', 'true');
      // Bring Step 1 back into view so user can reselect.
      bagCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (changeBtn) {
      changeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        expandBagCard();
      });
    }
    // ──────────────────────────────────────────────────────────────

    // ── Stock guard ────────────────────────────────────────────────────
    // data-stock-grams is published per product by inventory-ledger.py in whole
    // 100 g units. -1 (or missing) means "unknown" → no cap, so a metafield that
    // failed to publish can never block a sale.
    function stockOf(elOrId) {
      var el = typeof elOrId === 'string'
        ? root.querySelector('[data-candy][data-id="' + elOrId + '"]')
        : elOrId;
      if (!el) return -1;
      var g = parseInt(el.dataset.stockGrams, 10);
      return isNaN(g) ? -1 : g;
    }
    // Grams of this candy the customer may still add (Infinity when uncapped).
    function stockHeadroom(id) {
      var stock = stockOf(id);
      if (stock < 0) return Infinity;
      var picked = selectedCandies.get(id);
      return stock - (picked ? picked.grams : 0);
    }

    function addCandy(btn) {
      // HOTFIX: Block clicks during bag-full auto-upgrade to prevent race condition.
      if (isUpgrading) return;
      if (!selectedBag) {
        flashCta(FIXED ? (T.fixed_choose_style_first || T.cta_choose_bag_first) : T.cta_choose_bag_first);
        if (bagCard) bagCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var remaining = selectedBag.grams - totalGrams();
      if (remaining <= 0 && !FIXED) {
        if (upgradeToNextBag()) {
          // Mark upgrade in flight; unlock after animation completes.
          isUpgrading = true;
          setTimeout(function () { isUpgrading = false; }, 400);
          remaining = selectedBag.grams - totalGrams();
        } else {
          // STATE 2: bag is full — show upgrade toast once per fill.
          // hasShownUpgradeToast resets when bag empties or user switches bag.
          if (!hasShownUpgradeToast) {
            showUpgradeToast();
            hasShownUpgradeToast = true;
          }
          return;
        }
      }
      var id = btn.dataset.id;
      var headroom = stockHeadroom(id);
      if (headroom <= 0) {
        var s = stockOf(id);
        flashCta(s === 0 ? 'Sold out — pick another candy' : 'Only ' + s + 'g of that in stock');
        return;
      }
      // Never truncate the final scoop to make it fit exactly: an imperial bag
      // (454/907/1360/1814 g) would otherwise end on a part-scoop and the customer
      // would feel short-changed. Give the full 100 g and let the bag run over —
      // capped only by what we actually have in stock.
      var add = Math.min(GRAMS, headroom);
      var existing = selectedCandies.get(id);
      if (existing) {
        existing.grams += add;
      } else {
        selectedCandies.set(id, { id: id, title: btn.dataset.title, grams: add });
      }
      btn.classList.add('is-pulse');
      setTimeout(function () { btn.classList.remove('is-pulse'); }, 300);

      // STATE 1/2: just hit 100% (once per fill). Show celebration and
      // immediately offer the next bag size instead of requiring another tap.
      syncFullFlags();
      handleBagFullReached();
      render();
    }

    function adjustCandy(id, delta) {
      var c = selectedCandies.get(id);
      if (!c) return;
      if (delta > 0) {
        var remaining = selectedBag.grams - totalGrams();
        if (!FIXED && remaining <= 0 && upgradeToNextBag()) {
          remaining = selectedBag.grams - totalGrams();
        }
        // Any room left at all earns a full scoop (see addCandy) — overfill is fine.
        if (!FIXED && remaining <= 0) return;
        var headroom = stockHeadroom(id);
        if (headroom < delta) {
          flashCta('Only ' + stockOf(id) + 'g of that in stock');
          return;
        }
        c.grams += delta;
      } else {
        c.grams += delta;
        if (c.grams <= 0) selectedCandies.delete(id);
      }
      // Fire celebration if this increment just filled the bag.
      // Mirrors the STATE 1 check in addCandy — so a stepper (+) fill
      // celebrates too, not only a candy-card tap. Positive delta only.
      syncFullFlags();
      if (delta > 0) handleBagFullReached();
      render();
    }

    // One-click sidebar × — drop the candy entirely.
    function removeCandy(id) {
      if (!selectedCandies.has(id)) return;
      selectedCandies.delete(id);
      syncFullFlags();
      render();
    }

    function toggleUpsell(btn) {
      var id = btn.dataset.id;
      if (selectedUpsells.has(id)) {
        selectedUpsells.delete(id);
      } else {
        selectedUpsells.set(id, {
          id: id,
          variantId: btn.dataset.variantId,
          title: btn.dataset.title,
          price: parseInt(btn.dataset.price, 10),
          priceFormatted: btn.dataset.priceFormatted
        });
      }
      render();
    }

    function flashCta(msg) {
      if (!ctaLabel) return;
      var prev = ctaLabel.textContent;
      ctaLabel.textContent = msg;
      setTimeout(function () { ctaLabel.textContent = prev; }, 1600);
    }

    // ---- Filtering (23 Sep 2026): text search AND Brand/Flavor/Type/Dietary selects (same four filters as the collection pages) ----
    var filterSelects = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var filterClear = root.querySelector('[data-filter-clear]');
    var filterCount = root.querySelector('[data-filter-count]');
    var filterEmpty = root.querySelector('[data-filter-empty]');
    var filterQuery = '';
    function tileMatches(c) {
      if (filterQuery && (c.dataset.searchKey || '').indexOf(filterQuery) === -1) return false;
      for (var i = 0; i < filterSelects.length; i++) {
        var sel = filterSelects[i], v = sel.value;
        if (!v) continue;
        if (sel.dataset.filter === 'brand') { if ((c.dataset.brand || '') !== v) return false; }
        else {
          var list = c.dataset[sel.dataset.filter] || '';
          if (list.indexOf('|' + v + '|') === -1) return false;
        }
      }
      return true;
    }
    function applyFilters() {
      var shown = 0, active = !!filterQuery;
      filterSelects.forEach(function (s) { if (s.value) active = true; });
      candies.forEach(function (c) { var ok = tileMatches(c); c.hidden = !ok; if (ok) shown++; });
      if (filterClear) filterClear.hidden = !active;
      if (filterEmpty) filterEmpty.hidden = shown > 0;
      if (filterCount) filterCount.textContent = active ? (shown + ' / ' + candies.length) : '';
    }
    function filterCandies(q) {
      filterQuery = (q || '').toLowerCase().trim();
      applyFilters();
    }
    filterSelects.forEach(function (s) { s.addEventListener('change', applyFilters); });
    if (filterClear) filterClear.addEventListener('click', function () {
      filterSelects.forEach(function (s) { s.value = ''; });
      if (search) search.value = '';
      filterQuery = '';
      applyFilters();
    });

    // ---- Cart submission ----
    function buildMixContents() {
      var lines = [];
      selectedCandies.forEach(function (c) { lines.push(c.title + ' – ' + formatWeight(c.grams)); });
      return lines.join('\n');
    }

    // Hidden twin of Mix Contents for the stock ledger ONLY — never a packing
    // instruction. Pack what "Mix Contents" says (0.2 lb per click for imperial
    // customers); the ledger deliberately books a full 100 g per click so the
    // physical shelf always holds a little more than the books — a built-in
    // buffer against shrinkage (Ian, 27 Aug 2026). Underscore prefix keeps it
    // out of the customer's cart/order view.
    // Fixed-bag mode sends the line with quantity = number of bags, and the ledger multiplies every
    // "_Ledger grams" line by the quantity — so the grams here are PER BAG (total ÷ bags).
    function buildMixGrams(divisor) {
      var d = divisor && divisor > 1 ? divisor : 1;
      var lines = [];
      selectedCandies.forEach(function (c) {
        var g = Math.round((c.grams / d) * 100) / 100;
        lines.push(c.title + ' – ' + g + 'g');
      });
      return lines.join('\n');
    }

    async function addToCart() {
      if (!selectedBag) return;
      var t = totalGrams();
      var nBags = FIXED ? bagCount() : 1;
      if (FIXED) { if (!isExactlyFull()) return; } // fixed bag: only whole, full bags check out
      else if (t < selectedBag.grams) return; // SOFIA-FILL-1: defence-in-depth — block underfilled checkout
      
      // HOTFIX: Sanity-check all candy grams before submission.
      // Detects if a race condition corrupted the selectedCandies state.
      var hasNegativeOrZeroGrams = false;
      selectedCandies.forEach(function (c) {
        if (!c.grams || c.grams <= 0 || !Number.isFinite(c.grams)) {
          console.warn('[pick-mix] Invalid grams detected:', c);
          hasNegativeOrZeroGrams = true;
        }
      });
      if (hasNegativeOrZeroGrams) {
        flashCta('Error: corrupted state. Please reload and try again.');
        console.error('[pick-mix] State validation failed before cart submit');
        return;
      }
      
      ctaBtn.disabled = true;
      ctaBtn.classList.add('is-loading');
      if (ctaBtnMobile) ctaBtnMobile.disabled = true;

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      // Build FormData with multi-item syntax — matches Shopify Ajax API spec + the
      // theme's standard product-form pattern so cart-drawer-items.onCartUpdate
      // refreshes correctly. Bag is item 0 with line item properties; upsells
      // follow as items 1..N (no properties).
      var formData = new FormData();
      var bagNumericId = selectedBag.id.toString().replace(/^.*\//, '');
      formData.append('items[0][id]', bagNumericId);
      formData.append('items[0][quantity]', String(nBags));
      if (!FIXED && selectedBag.displayTitle && selectedBag.displayTitle !== selectedBag.title) {
        formData.append('items[0][properties][Size ordered]', selectedBag.displayTitle);
      }
      if (FIXED && nBags > 1) {
        formData.append('items[0][properties][Bags]', nBags + ' × ' + formatWeight(selectedBag.grams) + ' (mix below is the total across all bags)');
      }
      formData.append('items[0][properties][Mix Contents]', buildMixContents());
      formData.append('items[0][properties][_Ledger grams]', buildMixGrams(nBags));
      formData.append('items[0][properties][Total Weight]', formatWeight(t));
      formData.append('items[0][properties][_Packed grams]', t + 'g');
      selectedUpsells.forEach(function (u, i) {
        var idx = i + 1;
        var variantNumericId = u.variantId.toString().replace(/^.*\//, '');
        formData.append('items[' + idx + '][id]', variantNumericId);
        formData.append('items[' + idx + '][quantity]', '1');
      });

      // Request section re-render in same POST + record source element for a11y focus.
      // setActiveElement BEFORE fetch matches product-form.js order.
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      try {
        var res = await fetch(CART_ADD_URL, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: formData
        });
        var data = await res.json();
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'Cart error');
        }

        // CRITICAL: publish cartUpdate BEFORE renderContents — matches product-form.js.
        // Lets cart-drawer-items.onCartUpdate fire its own /cart?section_id=cart-drawer
        // fetch in flight; renderContents then swaps the fresh server HTML in. When the
        // onCartUpdate fetch resolves it replaces the wrapper with the latest state.
        // Reversing this order causes the drawer to render blank because the second fetch
        // overwrites our fresh content with a stale snapshot.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pick-mix', cartData: data });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        } else {
          window.location.href = CART_URL;
          return;
        }

        try {
          var cartRes = await fetch(CART_JSON_URL, {
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
          });
          var cartJson = await cartRes.json();
          if (cartRes.ok && typeof cartJson.total_price === 'number') {
            CURRENT_CART_TOTAL = cartJson.total_price;
            root.dataset.currentCartTotal = String(CURRENT_CART_TOTAL);
          } else {
            CURRENT_CART_TOTAL += total;
          }
        } catch (cartErr) {
          CURRENT_CART_TOTAL += total;
        }

        // Reset state
        selectedCandies.clear();
        selectedUpsells.clear();
        render();
      } catch (err) {
        console.error('[pick-mix] Add to cart failed', err);
        flashCta(T.error_generic);
      } finally {
        ctaBtn.classList.remove('is-loading');
        // Match product-form.js finally-block cleanup
        if (cart && cart.classList && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
        render();
      }
    }

    // ---- Wire events ----
    bags.forEach(function (b) { b.addEventListener('click', function () { userHasInteracted = true; selectBag(b, true); }); });
    candies.forEach(function (c) {
      c.addEventListener('click', function (e) {
        // Stepper buttons live inside the card div but must NOT trigger an add.
        if (e.target && e.target.closest && e.target.closest('[data-candy-dec],[data-candy-inc]')) return;
        addCandy(c);
      });
      // Outer is a <div role="button"> — restore keyboard activation (Enter/Space).
      c.addEventListener('keydown', function (e) {
        if (e.target && e.target.closest && e.target.closest('[data-candy-dec],[data-candy-inc]')) return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          addCandy(c);
        }
      });
      // Per-card stepper — stopPropagation so the outer card click doesn't also fire.
      var dec = c.querySelector('[data-candy-dec]');
      var inc = c.querySelector('[data-candy-inc]');
      if (dec) dec.addEventListener('click', function (e) { e.stopPropagation(); adjustCandy(c.dataset.id, -GRAMS); });
      if (inc) inc.addEventListener('click', function (e) { e.stopPropagation(); adjustCandy(c.dataset.id, GRAMS); });
    });
    upsellEls.forEach(function (u) { u.addEventListener('click', function () { toggleUpsell(u); }); });
    if (search) search.addEventListener('input', function (e) { filterCandies(e.target.value); });
    if (ctaBtn) ctaBtn.addEventListener('click', addToCart);
    if (ctaBtnMobile) ctaBtnMobile.addEventListener('click', addToCart);

    // ---- Init: pick default bag (middle = 1kg if present, else first) ----
    // Fixed bag with several styles: no default — the customer picks the style first.
    var defaultBag = FIXED ? (bags.length === 1 ? bags[0] : null) : (bags.find(function (b) {
      var t = (b.dataset.variantTitle || '').toLowerCase();
      return t.indexOf('1kg') !== -1 || t.indexOf('1 kg') !== -1;
    }) || bags[0]);
    if (defaultBag) selectBag(defaultBag);
    render();
  }

  function boot() {
    document.querySelectorAll('[data-pickmix]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
